var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"firstAccess-selection--container"},[(_vm.isReady)?_c('v-container',{staticClass:"firstAccess--body"},[_c('div',{staticClass:"welcome-decline-content-wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.$t('prospect.invite.error.title')))]),_c('h5',[_vm._v(" "+_vm._s(_vm.$t(_vm.subtitle)))])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }